// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__3XHxr","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__2WrzH"};